export const mapProviders = [
  {
    id: 1,
    name: 'default',
    displayName: 'Default',
  },
  {
    id: 2,
    name: 'google',
    displayName: 'Google Maps',
  },
  {
    id: 3,
    name: 'mapbox',
    displayName: 'Mapbox',
  },
]
